import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_7 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_card, { titulo: "DADOS DO LANÇAMENTO" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_form_item, {
                label: "N.Identificação",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedDetalhePagamento.numeroTitulo) = $event)),
                    disabled: _ctx.computedDetalhePagamento.alterado || _ctx.UtilitarioGeral.validaCodigo(_ctx.computedDetalhePagamento.codigo)
                  }, null, 8, _hoisted_5), [
                    [_vModelText, _ctx.computedDetalhePagamento.numeroTitulo]
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_form_item, {
                label: "Vencimento",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_data, {
                    dataSelecionada: _ctx.computedDetalhePagamento.dataVencimento,
                    "onUpdate:dataSelecionada": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedDetalhePagamento.dataVencimento) = $event)),
                    disabled: !_ctx.props.editavel
                  }, null, 8, ["dataSelecionada", "disabled"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_form_item, {
                label: "Valor",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_campo_numerico, {
                    monetario: true,
                    quantidadeCasasDecimais: 2,
                    valor: _ctx.computedDetalhePagamento.valor,
                    "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedDetalhePagamento.valor) = $event)),
                    disabled: !_ctx.props.editavel
                  }, null, 8, ["valor", "disabled"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_a_form_item, {
                label: "Observações/Descrição",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedDetalhePagamento.observacoes) = $event)),
                    disabled: !_ctx.props.editavel
                  }, null, 8, _hoisted_10), [
                    [_vModelText, _ctx.computedDetalhePagamento.observacoes]
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_selecionar_conta, {
                empresas: [_ctx.props.empresa],
                "codigo-selecionado": _ctx.computedDetalhePagamento.conta,
                "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedDetalhePagamento.conta) = $event)),
                "descricao-selecionado": _ctx.computedDetalhePagamento.descricaoConta,
                "onUpdate:descricaoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedDetalhePagamento.descricaoConta) = $event)),
                disabled: !_ctx.props.editavel
              }, null, 8, ["empresas", "codigo-selecionado", "descricao-selecionado", "disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_a_form_item, {
                label: "Categoria do Plano de Contas",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_categoria_plano_conta, {
                    empresas: [_ctx.props.empresa],
                    tipoPlanoConta: 1,
                    codigoSelecionado: _ctx.computedDetalhePagamento.codigoPlanoConta,
                    "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedDetalhePagamento.codigoPlanoConta) = $event)),
                    descricaoSelecionado: _ctx.computedDetalhePagamento.nomePlanoConta,
                    "onUpdate:descricaoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedDetalhePagamento.nomePlanoConta) = $event)),
                    disabled: !_ctx.props.editavel
                  }, null, 8, ["empresas", "codigoSelecionado", "descricaoSelecionado", "disabled"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}